<div class="gutter">
	<header #header class="flx-col flx-gap-default">
		<h1 #headerTitle>{{ (page | async).name }}</h1>
	</header>
	<div *ngIf="(auth.isLoggedIn | async).logged == true">
	<form [formGroup]="form" (submit)="submit()" novalidate class="flx-col flx-gap-default">

			<h4 i18n="@@uvinsearch">Wprowadź numer VIN przyczepy aby otrzymać certyfikat VDI</h4>

			<mat-form-field appearance="outline" class="w-100 noerror">
			<mat-label i18n="@@vinextended">Numer identyfikacyjny pojazdu (VIN)</mat-label>
			<input matInput formControlName="vin">
			<div *ngIf="loading_vin | async" class="loader-circle"></div>
			</mat-form-field>

			<p class="infobox error" *ngIf="(allowed | async) == 2">
				Nie znalazłem podanego VIN w naszej bazie przyczep
			</p>

			<mat-radio-group formControlName="type" class="flx-dynamic flx-gap-default">
				<mat-radio-button value="new">Przyczepa nowa</mat-radio-button>
				<mat-radio-button value="old">Przyczepa używana</mat-radio-button>
			</mat-radio-group>
				

			<div id="uploader" class="flx-col flx-gap-default flx-strt-strtch" *ngIf="form.get('type').value == 'old'">

				<p class="infobox">W celu weryfikacji prosimy o załączenie 4 zdjęć zgodnie ze wzorem dostępnym poniżej. Wszystkie punkty mocowania pasów muszą być widoczne.</p>
				<div class="gallery flx-row flx-wrap-grid flx-wrap-grid-4-sm">
					<div class="thumb" *ngFor="let image of (page | async).gallery">
					<img [src]="cdn+'/pages/'+image.dir+'/'+image.filename">
					</div>
				</div>

				<p class="infobox success" *ngIf="(uploaded | async).length > 0">
					<ng-container i18n="@@filesadded">Następujące pliki zostały dodane do zgłoszenia</ng-container>:<br>
					<span *ngFor="let item of (uploaded | async)">{{ item }}<br></span>
				</p>
				
				<p class="infobox error" *ngIf="(errored | async).length > 0">
					<ng-container i18n>Następujące pliki nie zostały dodane do zgłoszenia, wystąpił nieoczekiwany błąd</ng-container>:<br>
					<span *ngFor="let item of (errored | async)">{{ item.name }} {{ item.error }}<br></span>
					<ng-container i18n>Spróbuj jeszcze raz.</ng-container>
				</p>

				<div *ngIf="(uploaded | async).length < 4" ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (onFileDrop)="fileDropped($event)"  [uploader]="uploader" class="drop-zone flx-col flx-cntr-cntr">
					<div *ngIf="loading_file | async" class="loader-circle"></div>
					<div *ngIf="!(loading_file | async)">
						<span i18n="@@addvdiphotos">DODAJ ZDJĘCIA PRZECIĄGAJĄC JE TUTAJ LUB </span> <label class="fileselect" for="file" i18n="@@selectdrv">WYBIERZ Z DYSKU</label><input id="file" class="inputfile" type="file" ng2FileSelect (onFileSelected)="fileDropped($event)" [uploader]="uploader" multiple>
					</div>
				</div>
				<mat-error style="margin: 4px 8px;"  *ngIf="(uploaded | async).length == 0 && form.controls.rodo.dirty" i18n="@@error_req">To pole jest wymagane</mat-error>
				<p class="infobox error">Załączenie nieprawidłowych zdjęć skutkuje odrzuceniem wniosku</p>
				
			</div>

			<label class="switch rodo w-100 mb">
					<input #checkbox type="checkbox" formControlName="rodo">
					<span class="switch-style"></span>
					<span class="switch-txt">{{ (page | async).extra_field_4 }} <a [routerLink]="['/'+path_rules]" i18n="@@reg_here">Regulamin dostępny jest tutaj.</a></span>
					<mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n="@@rodoerror">Musisz wyrazić zgodę na przetwarzenie swoich danych osobowych.</mat-error>
			</label>

			<label class="switch rodo w-100 mb">
				<input #checkbox type="checkbox" formControlName="rodo1">
				<span class="switch-style"></span>
				<span class="switch-txt">{{ (page | async).extra_field_5 }}</span>
				<mat-error *ngIf="form.controls.rodo1.invalid && form.controls.rodo1.dirty" i18n="@@rodoerror">Musisz wyrazić zgodę na przetwarzenie swoich danych osobowych.</mat-error>
			</label>

			<p class="infobox error" *ngIf="result === 'error'" >{{ resultMessage }}</p>
			<div class="form-success" *ngIf="result === 'success' && (sent | async)" >
				<h1 i18n="@@simplethanks">Dziękujemy za wysłanie formularza</h1>
				<p i18n="@@vdiemail">Szczegóły otrzymania certyfikatu otrzymasz w e-mailu potwierdzającym zgłoszenie.</p>
			</div>

			<div class="flx-row flx-strt-cntr flx-gap-default mt">
				<button class="flat-button primary fat" (click)="submit()"  [disabled]="(sent | async) || (loading | async) || (allowed | async) == 0 || (allowed | async) == 2" i18n="@@send">Wyślij zgłoszenie</button>
				<div *ngIf="loading | async" class="loader-circle"></div>
			</div>	

	</form>

	<hr>
	</div>

	<form [formGroup]="searchForm" novalidate class="flx-col flx-gap-default">
		<h4 i18n="@@uvinsearch">Wprowadź numer VIN przyczepy aby sprawdzić ważność certyfikatu VDI</h4>

		<mat-form-field appearance="outline" class="w-100 noerror">
		<mat-label i18n="@@vinextended">Numer identyfikacyjny pojazdu (VIN)</mat-label>
		<input matInput formControlName="vin">
		<div *ngIf="loading_vin_client | async" class="loader-circle"></div>
		</mat-form-field>

		<p class="infobox error" *ngIf="(search_result | async) == 2">
			Przyczepa nie posiada aktualnego certyfikatu VDI
		</p>

		<p class="infobox success" *ngIf="(search_result | async) == 1">
			Przyczepa posiada aktualny certyfikat VDI
		</p>

	</form>

</div>